import { KEYWORDS_DEFAULT, DESCRIPTION_DEFAULT } from "@/constant/seo";

export const changeInformationSEO = (keywords=null, description=null) =>{
    const keywordsElement = document.getElementById("keywords-site");
    const descriptionElement = document.getElementById("description-site");

    keywordsElement.attributes.content.value = keywords ?? KEYWORDS_DEFAULT;
    descriptionElement.attributes.content.value = description ?? DESCRIPTION_DEFAULT;
}
